import React from "react";
import _ from 'lodash';
import Text from "../../../../../Commun/Inputs/Text/Text";
import Select from "../../../../../Commun/Inputs/Select/Select";
import Iban from "../../../../../Commun/Iban/Iban";
import Autocomplete from "../../../../../Commun/Inputs/Autocomplete/Autocomplete";
import SinistreVetuste from "../../../../../Commun/Inputs/SinistreVetuste/SinistreVetuste";

export const renderInputByType = ({ props, file, disabled, showLabel, correction, fields }) => {
    const { setFieldValue, values, errors, handleChange, handleBlur, setFieldError, setFieldTouched } = props;
    const inputName = file.input_name;
    const fieldData = values.data?.[inputName];
    const fieldState = fieldData?.state;
    const dateSurv = props?.task?.accident?.dateSurv;

    const name = disabled ? inputName : `data[${inputName}][new_value]`;
    const value = disabled ? (values[inputName] || file.default_value) : fieldData?.new_value;
    const error = disabled ? errors[inputName] : errors.data?.[inputName]?.new_value;

    const isValid = !correction && fieldState;
    const labelText = showLabel ? (correction ? 'Saisir la valeur présente sur le document' : file.label) : null;
    const isTouched = fieldData && Object.keys(fieldData).length > 0;

    if (file.automatic_validation === true && file.editable === false) {
        setFieldValue(`data[${inputName}][state]`, '1');
    }

    const renderSinistreVetuste = (valeurAchatFieldName, isMAE = false) => (
        <SinistreVetuste
            isValid={isValid}
            name={name}
            onChange={handleChange}
            onBlur={handleBlur}
            value={value || ""}
            required
            placeholder={file.label}
            label={labelText}
            maxLength={file.max_length}
            disabled={disabled}
            additional_label={file.additional_label}
            values={values}
            file={file}
            error={error}
            touched={isTouched}
            setFieldValue={setFieldValue}
            setFieldError={setFieldError}
            setFieldTouched={setFieldTouched}
            showLabel={showLabel}
            valeurAchatFieldName={valeurAchatFieldName}
            dateAchatFieldName="EXTERNE-DATE_FACTURE"
            dateSurv={dateSurv}
            isMAE={isMAE}
        />
    );

    switch (file?.type) {
        case 'date':
        case 'text':
        case 'number':
        case 'year':
            return (
                <Text
                    isValid={isValid}
                    type={_.includes(['text', 'number'], file.type) ? 'text' : file.type}
                    name={name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={_.isString(value) ? value?.toUpperCase() : value || ""}
                    required
                    placeholder={file.label}
                    label={labelText}
                    maxLength={file.max_length}
                    disabled={disabled}
                    additional_label={file.additional_label}
                    values={values}
                    file={file}
                />
            );

        case 'select':
            return (
                <Select
                    name={name}
                    error={error}
                    value={value || ""}
                    label={showLabel ? file.label : null}
                    disabled={disabled}
                    additional_label={file.additional_label}
                    required
                >
                    <option value="">{file.label}</option>
                    {_.map(file.field_select_values, option => (
                        <option value={option.key} key={option.key}>{option.value}</option>
                    ))}
                </Select>
            );

        case 'autocomplete':
            return (
                <Autocomplete
                    data={_.map(file.field_select_values, option => ({
                        label: option.value,
                        value: option.key
                    }))}
                    value={value || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name={name}
                    placeholder={file.label}
                    label={showLabel ? file.label : null}
                    error={error}
                    disabled={disabled}
                    additional_label={file.additional_label}
                    showLabel={showLabel}
                    isValid={!correction && fieldState === '1'}
                    setFieldValue={setFieldValue}
                    required
                />
            );

        case 'indicativeFieldsGroup':
            return (
                <div>
                    <label className="mb-2"><b>{file.additional_label}</b> {file.label}</label>
                    <div className="form-group no-input pb-2" style={{ height: 'auto' }}>
                        <div className="row">
                            {_.map(file.default_value, (v, index) => (
                                <div className="col-6 mb-2" key={v.label || index}>
                                    <p>{v.label}</p>
                                    <p className="text-white">{v.value}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );

        case 'iban':
            return (
                <Iban
                    label={labelText}
                    correction={correction}
                    file={file}
                    handleBlur={handleBlur}
                    values={values}
                    name={name}
                    handleChange={handleChange}
                    value={value}
                    disabled={disabled}
                    setFieldValue={setFieldValue}
                    nameBic={_.find(fields, ["label", "Code BIC"])?.input_name}
                    nameDomiciliation={_.find(fields, ["label", "Domiciliation"])?.input_name}
                />
            );

        case 'info':
            return (
                <div className="alert alert-warning m-0" role="alert">
                    {file.label} : {file.default_value} mois
                </div>
            );

        case 'sinistre_vetuste_mae':
            return renderSinistreVetuste('EXTERNE-VAL_ACHAT', true);

        case 'sinistre_vetuste_accessoire':
            const idAccessoire = inputName.split('_')[1];
            return renderSinistreVetuste(`EXTERNE-RE_${idAccessoire}_TYPE_ACCS_EQUIPT_VAL_ACHAT`);

        default:
            const stateClass = fieldState === '1' ? 'success-input' : fieldState === '0' ? 'error-input' : 'no-input';
            return (
                <div className={`form-group no-input ${stateClass}`}>
                    <label><b>{file.additional_label}</b> {file.label}</label>
                </div>
            );
    }
};
